import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';
import adminReducer from 'features/Admin/adminSlice';
import filterReducer from 'components/DrawerFilter/filterSlice';

const sagaMiddleware = createSagaMiddleware();


export const store = configureStore({
  reducer: {
    adminReducer,
    filterReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware)
});


sagaMiddleware.run(rootSaga);